import React from 'react';
import moment from 'moment';
import Attachment from '../attachment/index';
import './index.less';
class Node extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data || [],
            STATUS: {
                0:'审批中',
                1:'已退回',
                2:'已审核',
                3:'已跳过',
                6:'已作废',
                7:'已撤销',
                8:'已关闭',
                11:'驳回',
            }
        };
    }

    render() {
        const {data} = this.state;
        const _this = this;
        return (
            <div className="NodeBox">
                {
                    data.map((item, i)=>{
                        const attachments = item.attachments ? JSON.parse(item.attachments) : [];
                        return (
                            <div className="nodeContentBox" key={'node_' + i}>
                                <h3 className="nodeName">
                                    {item.nodeName}
                                    {item.nodeAttr != 'X' && item.status == '0' ? (<span>审批中</span>) : ''}
                                </h3>
                                {
                                    item.nodeAttr !== 'E' ? item.child.map((obj,j)=>{
                                        const time = moment.duration(obj.dealTime, 'seconds');
                                        const hours = time.hours();
                                        const minutes = time.minutes();
                                        const seconds = time.seconds();
                                        let timeText = '';
                                        if(hours > 0){
                                            timeText += hours + '时';
                                        }
                                        if(minutes > 0){
                                            timeText += minutes + '分';
                                        }
                                        if(seconds > 0){
                                            timeText += seconds + '秒';
                                        }

                                        return (
                                            <div className="nodeAll" key={'nodeAll_'+j}>
                                                <div className="nodeStaff">
                                                    {obj.checkUserName || obj.startUserName}/{obj.checkJobCard || obj.startJobCard}
                                                    {obj.memo ? (<span>；{obj.memo}</span>) : ''}
                                                    {/* {!obj.memo && obj.nodeAttr == 'X' ? obj.reStar == '1' ? '；提交成功': '；申请成功' : ''} */}
                                                    {!obj.memo && obj.nodeAttr != 'X' ? obj.nodeAttr =='G' && obj.status == '0' ? '': (<span>；{_this.state.STATUS[obj.status]}</span>) : ''}
                                                    <div className="nodeTime">{obj.lastNodes === 'X' ? obj.gmtCreate : obj.gmtOperate}</div>
                                                </div>
    
                                                {obj.context ? (
                                                    <div className={'nodeText ' + ((obj.status == 11 || obj.status == 1) && obj.lastNodes !== 'X' ? 'textRed' : '')}>
                                                        {obj.context}
                                                    </div>
                                                ) : ''}
    
                                                <div className="nodeFile" style={{ marginTop: obj.attachments ? '0.12rem' : 0 }}>
                                                    <Attachment fileData={obj.attachments ? JSON.parse(obj.attachments) : []} />
                                                </div>
                                                
                                                {i === 0 || obj.dealTime == 0 || !obj.dealTime ? '' : (
                                                    <div className="nodeTime textRight">
                                                        处理时长：{obj.nodeAttr === 'X' ? '' : timeText || '--'}
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }) : ''
                                }
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default Node;


// WEBPACK FOOTER //
// ./src/processReview/modules/node/index.js